<div class="container mx-auto max-w-screen-lg">
    <h1 class="pb-4 text-center">Gespeicherte Fragen</h1>

    @if(bookmarkedQuestions.length == 0){
    <div class="shadow-box flex flex-col items-center max-w-screen-sm mb-4">
        <p>In diesem Bereich erscheinen Fragen, die du gespeichert hast. Um Fragen zu speichern, halte Ausschau nach
            diesem Icon:</p>
        <ng-icon class="text-blue" size="25" name="bootstrapJournalBookmark"></ng-icon>
    </div>
    }

    @for(bookmarkedQuestion of bookmarkedQuestions; track bookmarkedQuestion; let index = $index){
    <details class="group bg-background-dark rounded mb-2 mr-6 ml-6 py-1 px-3">
        <summary class="flex items-center text-blue cursor-pointer list-none">
            <svg class="flex-shrink-0 mr-2" fill="none" height="24" shape-rendering="geometricPrecision"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                viewBox="0 0 24 24" width="20">
                <path d="M6 9l6 6 6-6"></path>
            </svg>

            <div
                class="flex-shrink-0 bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-100 text-xs font-semibold mr-2 px-2 py-1 rounded">
                {{ bookmarkedQuestion.created | timeAgo }}
            </div>

            @if(bookmarkedQuestion.expand?.course?.name){
            <div
                class="flex-shrink-0 bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-100 text-xs font-semibold mr-2 px-2 py-1 rounded">
                {{ bookmarkedQuestion.expand?.course?.name }}
            </div>
            }

            <span class="hidden md:block flex-grow whitespace-nowrap overflow-hidden text-ellipsis">
                {{ bookmarkedQuestion.expand?.answered_question?.expand?.question?.value }}
            </span>
        </summary>
        <div class="py-4 bg-background group-open:animate-fadeIn rounded">
            <app-answer [showFlag]="false" [question]="bookmarkedQuestion.expand?.answered_question?.expand?.question"
                [evaluation]="bookmarkedQuestion.evaluation" [bookmarked]="true"
                [bookmarkInfo]="{responseId: bookmarkedQuestion.answered_question, courseId: bookmarkedQuestion.course}"
                [orderSeed]="bookmarkedQuestion.expand?.answered_question?.order_seed"></app-answer>
        </div>
    </details>
    }
</div>